export const DEFAULT_IMAGE_SIZE = {
  WIDTH: 360,
  HEIGHT: 480,
}

export const SIDE_CONTENT_IMAGE_SIZE = {
  WIDTH: 128,
  HEIGHT: 228,
}
